import React from "react";

const CTAButtton2 = ({
  text = "Get OTP",
  onClick,
  disabled = false,
  className = "",
  id = "",
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      id={id}
      className={`w-full py-3 flex justify-center items-center gap-2 rounded-md text-[16px] 
        font-normal font-[Atkinson_Hyperlegible] transition-all duration-200
        ${
          disabled
            ? "bg-gray-400 cursor-not-allowed text-black/80"
            : "bg-[#12F280] hover:bg-[#0fd471] cursor-pointer text-black"
        } 
        ${className}`}
    >
      {text}
      <img
        src="/assets/img/cta_arrow_new.png"
        alt="arrow"
        className="w-[18px] h-[18px] object-contain"
      />
    </button>
  );
};

export default CTAButtton2;
